import { buildApiRequest } from 'utils/api';
import { BASE_URL } from 'utils/urls';

const urlHelper = {
  getContentList: (params: any) => buildApiRequest('GET', `${BASE_URL}/odin/v1/seo-cms/pages`, params),
  getContentDetails: (params: any) => buildApiRequest('GET', `${BASE_URL}/odin/v1/seo-cms/page`, params),
  postSaveContentDetails: (params: any) => buildApiRequest('POST', `${BASE_URL}/odin/v1/seo-cms/page`, params),
  postPublishContentDetails: (params: any) => buildApiRequest('POST', `${BASE_URL}/odin/v1/seo-cms/publish`, params),
};

export default urlHelper;
